import React from 'react';
import {
  TableHead,
  TableRow,
} from '../../../../../../components/customTableComponents';
import { callListColumns } from '../../constants';
import CallListHeadCell from '../CallListHeadCell/CallListHeadCell';

const CallListHead = ({
  onRecordsSort,
  orderBy,
  order,
  filters,
  filteredInfo,
  setFilteredInfo,
}) => {
  const handleCreateSort =
    ({ property, sortType }) =>
    () => {
      onRecordsSort({ property, sortType });
    };

  const handleFilterConfirm = (filterKey) => (keys) => {
    setFilteredInfo({ ...filteredInfo, [filterKey]: keys });
  };

  const handleFilterReset = (filterKey) => () => {
    setFilteredInfo({ ...filteredInfo, [filterKey]: [] });
  };

  return (
    <TableHead>
      <TableRow>
        {callListColumns.map((column) => (
          <CallListHeadCell
            key={column.key}
            column={column}
            onSortClick={handleCreateSort({
              property: column.key,
              sortType: column.sortType,
            })}
            direction={orderBy === column.key ? order : ''}
            onFilterConfirm={handleFilterConfirm(column.filterKey)}
            onFilterReset={handleFilterReset(column.filterKey)}
            selectedItems={filteredInfo?.[column.filterKey]}
            filtered={filteredInfo?.[column.filterKey]?.length}
            filterItems={filters[column.filterKey]}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CallListHead;
